import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { copyImportedProcedures } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function duplicateImportedProcedure({
  accountId,
  selectedDuplicates,
  visibility,
}: TVariables): Promise<TResult> {
  const response = await fetch(copyImportedProcedures(accountId, visibility), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(selectedDuplicates),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  selectedDuplicates: Array<any> | undefined;
  visibility: string;
};

type TSnapshot = unknown;

function useForceImportProcedures(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const result = await duplicateImportedProcedure(params);
    if (result.Data) {
      queryClient.invalidateQueries(['get_procedure_builder_procedures'], {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(['get_global_procedures'], {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(['get_archived_procedures'], {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(['get_procedure'], {
        refetchInactive: true,
      });
    } else if (result.Errors) throw result;
    return result;
  });
}

export { useForceImportProcedures };
